import { Link } from "react-router-dom";
import { Page } from "../../components/page/page";
import { useLocalization } from "../../hooks/use-localization/useLocalization";

export const Otp: React.FC = () => {
  const { localize } = useLocalization();

  return (
    <Page title={localize("otp:title")}>
      <h2 className="h3">{localize("otp:subtitle")}</h2>
      <Link className="button large" to="nokkel">
        <svg
          width="56"
          height="30"
          viewBox="0 0 56 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M50.5 10H29.625C28.5952 7.07621 26.6834 4.54406 24.1534 2.75291C21.6234 0.961758 18.5999 -0.000114484 15.5 1.02202e-08C7.225 1.02202e-08 0.5 6.725 0.5 15C0.5 23.275 7.225 30 15.5 30C18.5999 30.0001 21.6234 29.0382 24.1534 27.2471C26.6834 25.4559 28.5952 22.9238 29.625 20H30.5L35.5 25L40.5 20L45.5 25L55.5 14.9L50.5 10ZM15.5 22.5C11.375 22.5 8 19.125 8 15C8 10.875 11.375 7.5 15.5 7.5C19.625 7.5 23 10.875 23 15C23 19.125 19.625 22.5 15.5 22.5Z" />
        </svg>
        {localize("otp:key")}
      </Link>
      <Link className="button large" to="qr">
        <svg
          width="46"
          height="46"
          viewBox="0 0 46 46"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.5 20.5H20.5V0.5H0.5V20.5ZM5.5 5.5H15.5V15.5H5.5V5.5ZM0.5 45.5H20.5V25.5H0.5V45.5ZM5.5 30.5H15.5V40.5H5.5V30.5ZM25.5 0.5V20.5H45.5V0.5H25.5ZM40.5 15.5H30.5V5.5H40.5V15.5ZM40.5 40.5H45.5V45.5H40.5V40.5ZM25.5 25.5H30.5V30.5H25.5V25.5ZM30.5 30.5H35.5V35.5H30.5V30.5ZM25.5 35.5H30.5V40.5H25.5V35.5ZM30.5 40.5H35.5V45.5H30.5V40.5ZM35.5 35.5H40.5V40.5H35.5V35.5ZM35.5 25.5H40.5V30.5H35.5V25.5ZM40.5 30.5H45.5V35.5H40.5V30.5Z" />
        </svg>
        {localize("otp:qr")}
      </Link>
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
